// extracted by mini-css-extract-plugin
export default {"cwc-selection__buttons":"SelectionTab_cwc-selection__buttons__O-8kz"};